"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeNotifyAsisEvent = exports.publishNotifyAsisEvent = exports.NotifyAsisTypeEvent = void 0;
const factory_1 = require("./factory");
const events_1 = require("../events");
var NotifyAsisTypeEvent;
(function (NotifyAsisTypeEvent) {
    NotifyAsisTypeEvent["NOTIFY_ASIS_EVENT"] = "notifyAsisEvent";
})(NotifyAsisTypeEvent || (exports.NotifyAsisTypeEvent = NotifyAsisTypeEvent = {}));
exports.publishNotifyAsisEvent = (0, factory_1.createPublishFunction)(NotifyAsisTypeEvent.NOTIFY_ASIS_EVENT, events_1.NotifyAsisEvent);
exports.subscribeNotifyAsisEvent = (0, factory_1.createSubscribeFunction)(NotifyAsisTypeEvent.NOTIFY_ASIS_EVENT);
//# sourceMappingURL=asis.js.map